import { component } from 'picoapp';
import fetchSection from 'utils/fetch-section';

interface BlogConfig {
  sectionId: string
}

interface ArticleListConfig {
  pages: number,
}

export default component(async (node) => {
  const tagListWrapper = node.querySelector('[data-tag-list-wrapper]');
  const tagLinks = Array.from(node.querySelectorAll<HTMLAnchorElement>('[data-tag-link]'));
  const viewPrevBtn = node.querySelector('[data-view-prev-btn]');
  const viewMoreBtn = node.querySelector<HTMLAnchorElement>('[data-view-more-btn]');
  const articleList = node.querySelector('[data-article-list]');
  const paginationInfo = node.querySelector('[data-pagination-info]');

  const config: BlogConfig = JSON.parse(node.dataset.config);
  const { sectionId } = config;

  const initTagList = () => {
    const currentTagLink = tagLinks.find((link) => (
      link.href === window.location.href
    ));

    if (currentTagLink) {
      const rect = currentTagLink.getBoundingClientRect();
      tagListWrapper.scrollTo(rect.right - ((window.innerWidth / 2) + (rect.width / 2)), 0);
    }
  };

  const initPagination = () => {
    const loadPreviousPages = async () => {
      const currentUrl = new URL(window.location.href);
      const currentPage = parseInt(currentUrl.searchParams.get('page'), 10);

      const fetches = [];

      for (let page = 1; page < currentPage; page += 1) {
        currentUrl.searchParams.set('page', page.toString());
        fetches.push(fetchSection(currentUrl, sectionId, false));
      }

      const html = (await Promise.all(fetches)).map((container) => (
        container.querySelector('[data-article-list]')
      )).map((list) => (
        list.innerHTML
      )).join('');

      articleList.insertAdjacentHTML('afterbegin', html);

      viewPrevBtn.remove();
    };

    const loadNextPage = async () => {
      let currentUrl = new URL(window.location.href);
      const nextPage = parseInt(currentUrl.searchParams.get('page') || '1', 10) + 1;

      currentUrl.searchParams.set('page', nextPage.toString());

      const container = await fetchSection(currentUrl, sectionId, true);
      const containerList = container.querySelector<HTMLElement>('[data-article-list]');
      const html = containerList.innerHTML;

      articleList.insertAdjacentHTML('beforeend', html);

      const containerPaginationInfo = container.querySelector('[data-pagination-info]');
      paginationInfo.innerHTML = containerPaginationInfo.innerHTML;

      const articleListConfig: ArticleListConfig = JSON.parse(containerList.dataset.config);
      const { pages } = articleListConfig;

      if (nextPage >= pages) {
        viewMoreBtn.remove();
      } else {
        currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('page', (nextPage + 1).toString());
        viewMoreBtn.href = currentUrl.toString();
      }
    };

    viewPrevBtn?.addEventListener('click', loadPreviousPages);
    viewMoreBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      loadNextPage();
    });
  };

  const init = () => {
    initTagList();
    initPagination();
  };

  init();
});
